(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('ApExceptionsConfirmModalController', ["$scope", "$modalInstance", "options", function ($scope, $modalInstance, options) {
        $scope.options = $.extend({ title: 'Confirmation dialog' }, options);
        if ($scope.options.exception_type === 'blacklist') {
            $scope.params = [
                {
                    id: 'comment',
                    label: 'Comment',
                    order: 1,
                    type: 'text',
                    data: '',
                    additionalLabel: true
                },
                {
                    id: 'quarantine_all',
                    order: 2,
                    type: 'boolean',
                    rightLabel: 'Quarantine matched emails (approximately ' + $scope.options.total + ' email' + ($scope.options.total > 1 ? 's' : '') + ')',
                    emptyLabel: true,
                    data: false
                }
            ];
            $scope.options.titleExplanation = 'A Block-List rule will be created with the following criteria:';
        } else {
            $scope.params = [
                {
                    id: 'ignoring_spf_check',
                    order: 1,
                    type: 'boolean',
                    rightLabel: 'Ignore SPF (not recommended)',
                    emptyLabel: true,
                    data: false
                },
                {
                    id: 'comment',
                    label: 'Comment',
                    order: 2,
                    type: 'text',
                    data: '',
                    additionalLabel: true
                },
                {
                    id: 'release_all',
                    order: 3,
                    type: 'boolean',
                    rightLabel: 'Release emails that match criteria from quarantine (approximately ' + $scope.options.total + ' email' + ($scope.options.total > 1 ? 's' : '') + ')',
                    emptyLabel: true,
                    data: true
                }
            ];
            $scope.options.titleExplanation = 'An Allow-List rule will be created with the following criteria:';
        }
        $scope.results = [];
        $scope.ok = function () {
            _($scope.params).each(function (param, key) {
                $scope.results.push({
                    id: param.id,
                    data: param.data
                });
            });
            $modalInstance.close($scope.results);
        };
        $scope.close = function () {
            $modalInstance.dismiss();
        };
    }]);
    m.factory('apExceptionsConfirmModal', ["$modal", "path", function ($modal, path) {
        return {
            show: function (options) {
                var modalInstance = $modal.open({
                    templateUrl: path('gui-v2').ctrl('ap-exceptions-confirm-modal').template(),
                    controller: 'ApExceptionsConfirmModalController',
                    size: 'lg',
                    backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                    keyboard: _(options).isObject() && !_(options.keyboard).isUndefined() ? options.keyboard : true,
                    resolve: { options: _.constant(options) },
                    windowClass: 'ap-avanan-add-blacklist-modal-window'
                });
                return modalInstance.result;
            }
        };
    }]);
}());